import React, { useRef, useState, useEffect, Suspense } from 'react';
import useHttpApiCall from '../../../services/useHttpApiCall';
import { useLocation } from 'react-router';
import { lineTempAndHumChartFilterButtons } from '../../../config/chartFilterButtons';
import { customWidgetEndpointLayers, customWidgetEndpoints } from '../../../config/widgetEndpoints';
import widgetApiParams from '../../../utilities/widget.api.params';
import processInstantaneousPowerChartConfig from '../../../common/chartdataconfig/mainLayoutConfig/main.process.instantaneous.power.chart.config';
import RefreshMultipleTimeseries from '../../../common/chartautorefresh/refresh.multiple.timeseries';
import { useSelector } from 'react-redux';
import MachineLayoutComponent from '../../machinedetail/components/machinelayout.component';
import DateRangeSet from '../../../common/datetimepicker/daterangeset';

export default function CustomTimeSeriesContainer(props) {
  console.log("timeseries", props)
  const INITIALFILTER = '1day';
  // const [chartData, setChartData] = useState(undefined);
  const charRef = useRef(undefined);
  const [chartApiData, setChartApiData] = useState([]);
  const [payload, setPayload] = useState(undefined);
  const [payload2, setPayload2] = useState(undefined);
  const [selectEquipments, setSelectEquipments] = useState(null);
  const set_equipment_filter = useSelector((state) => state.equipmentFilter.set_equipment_filter);
  const [graphFilter, setGraphFilter] = useState({
    filterMain: INITIALFILTER
  });
  const onSidbarClick = useSelector((state) => state.sidebarClick.linkClick);
  const [apiParams, setApiParams] = useState(null);
  const [lastTimeStamp, setLastTimeStamp] = useState(null);
  const [toggleHumidity, setToggleHumidity] = useState(false);
  const hasHumidityToggle=true
  const [config,setConfig]=useState({})
  const location = useLocation();
    const [filterByDateCheck, setFilterByDateCheck] = useState(false);
    const [dateRange, setDateRange] = useState([null, null]);
      const [apiDateRange, setApiDateRange] = useState([]);
    
  const flexibleEquipmentEnabled=localStorage.getItem('flexible_equipment')=='true'?true:false
  const graphInfo = {
    isSummaryGraph: false
  }
  useEffect(()=>{
    setConfig({...processInstantaneousPowerChartConfig(chartApiData, graphFilter, props.graph_name || props.name),legend: { enabled: false }}) 
  },[chartApiData,toggleHumidity])
  const getSubDivision=()=>{
    let currentSub_division=props.sub_division
    return(toggleHumidity?currentSub_division+',2':currentSub_division)
  }
  const graphApiCall = () => {
    if(flexibleEquipmentEnabled){
      if(props?.layer_type=='temp_hum'){
        setPayload({
          auth: true,
          url: customWidgetEndpointLayers.timeSeries,
          params: { ...apiParams,plant_code:props?.plant_code,layer_type:props?.layer_type, layer_id:props?.layer_id,sensor_type:toggleHumidity?'temperature_and_humidity':props?.sensor_type }
        })
      }
      else{
        setPayload({
          auth: true,
          url: customWidgetEndpointLayers.timeSeries,
          params: { ...apiParams,plant_code:props?.plant_code,layer_type:props?.layer_type, layer_id:props?.layer_id }
        })
      }
    }
    else{
      setPayload({
        auth: true,
        url: customWidgetEndpoints.timeSeries,
        params: { ...apiParams, sub_division: getSubDivision() }
      })
    }
    charRef.current.chart.zoomOut();
    charRef.current.chart.showLoading();
  };

  const graphAddPointApiCall = () => {
    // eslint-disable-next-line no-unused-vars
    const { duration, ...modifiedParams } = apiParams;

    console.log("-----------", props.sub_division)
    flexibleEquipmentEnabled?  setPayload2({
      auth: true,
      url: customWidgetEndpointLayers.timeSeries,
      params: {
        ...modifiedParams,
        last_reading_time: lastTimeStamp,
        sub_division: props.sub_division
      }
    }):
    setPayload2({
      auth: true,
      url: customWidgetEndpoints.timeSeries,
      params: {
        ...modifiedParams,
        last_reading_time: lastTimeStamp,
        sub_division: props.sub_division
      }
    });
  };

  useEffect(() => {
    if (onSidbarClick) {
      setGraphFilter((prev) => ({
        ...prev,
        filterMain: INITIALFILTER,
        filterSecondary: graphFilterObject[INITIALFILTER].dropdown[0]
      }));
      charRef.current.chart.zoomOut();
    }
  }, [onSidbarClick]);

  useEffect(() => {
    if (apiParams) {
      graphApiCall();
    }
  }, [apiParams,toggleHumidity,props?.plant_code,dateRange]);

  useEffect(() => {
    if (
      set_equipment_filter.filter_update &&
      set_equipment_filter.params.sub_division == props.sub_division
    ) {
      graphApiCall();
    }
    else if(set_equipment_filter.filter_update && toggleHumidity && String(set_equipment_filter?.params?.sub_division)?.indexOf(',') !== -1 ){
      graphApiCall();

    }
  }, [set_equipment_filter.filter_update]);

  useEffect(() => {
    if (graphFilter || location.pathname) {
      setApiParams(widgetApiParams('ProcessInstantaneousPower', props, graphFilter, filterByDateCheck,
        apiDateRange,
        INITIALFILTER));
    }
  }, [graphFilter, location.pathname,apiDateRange]);

  const graphFilterObject = lineTempAndHumChartFilterButtons;
  const [data, loading] = useHttpApiCall(payload);
  useEffect(() => {
    if (data && data.data) {
      let apiData = data.data.data;
      setChartApiData(apiData);

      if(toggleHumidity){
        flexibleEquipmentEnabled?   setSelectEquipments({
          equipment_length: apiData.equipments_count,
          is_equipment_filter_enabled: apiData.is_equipment_filter_enabled,
          equipmet_list_api_url: 'v1/layers/equipments/',
          equipmet_list_params: {
            get_equipment_preference: 1,
            sub_division:getSubDivision(),
            process_id: apiData.process_id,
            plant_code:props?.plant_code,layer_type:props?.layer_type,
            sensor_type:toggleHumidity?'temperature_and_humidity':props?.sensor_type
          },
          drilldown_level: 'custom',
          equipment_update_params: {
            is_humidity_overlay:toggleHumidity?1:0,
          // sub_division: props.sub_division,
            process_id: apiData.process_id,
          }
        }):
        setSelectEquipments({
          equipment_length: apiData.equipments_count,
          is_equipment_filter_enabled: apiData.is_equipment_filter_enabled,
          equipmet_list_api_url: 'v0/equipments/',
          equipmet_list_params: {
            get_equipment_preference: 1,
            sub_division:getSubDivision(),
            process_id: apiData.process_id
          },
          drilldown_level: 'custom',
          equipment_update_params: {
            is_humidity_overlay:toggleHumidity?1:0,
          // sub_division: props.sub_division,
            process_id: apiData.process_id,
          }
        });
      }
      else{
        flexibleEquipmentEnabled?setSelectEquipments({
          equipment_length: apiData.equipments_count,
          is_equipment_filter_enabled: apiData.is_equipment_filter_enabled,
          equipmet_list_api_url: 'v1/layers/equipments/',
          equipmet_list_params: {
            get_equipment_preference: 1,
            sub_division:getSubDivision(),
            process_id: apiData.process_id
            ,plant_code:props?.plant_code,layer_type:props?.layer_type,
            sensor_type:toggleHumidity?'temperature_and_humidity':props?.sensor_type
          },
          drilldown_level: 'custom',
          equipment_update_params: {
            is_humidity_overlay:toggleHumidity?1:0,
          sub_division: props.sub_division,
            process_id: apiData.process_id,
          }
        }):
         setSelectEquipments({
          equipment_length: apiData.equipments_count,
          is_equipment_filter_enabled: apiData.is_equipment_filter_enabled,
          equipmet_list_api_url: 'v0/equipments/',
          equipmet_list_params: {
            get_equipment_preference: 1,
            sub_division:getSubDivision(),
            process_id: apiData.process_id
          },
          drilldown_level: 'custom',
          equipment_update_params: {
            is_humidity_overlay:toggleHumidity?1:0,
          sub_division: props.sub_division,
            process_id: apiData.process_id,
          }
        });
      }
      setLastTimeStamp(apiData.last_updated_time);
      charRef.current.chart.hideLoading();
    }
  }, [data]);

  return (
    <div className="two-layout">
      <Suspense fallback={<span>Loadiing</span>}>
        <MachineLayoutComponent
          chartApiData={chartApiData}
          loading={loading}
          chartData={config}
          charRef={charRef}
          expandWindow={props.expandWindow}
          minimizeWindow={props.minimizeWindow}
          shouldExpand={props.shouldExpand}
          chartId={props.id}
          hasFilter={true}
          graphFilter={graphFilter}
          setGraphFilter={setGraphFilter}
          graphFilterObject={graphFilterObject}
          selectEquipments={selectEquipments}
          filterByDate={true}
          hasSettings={props.graph_name==='Temperature (°C)' || props.name==='Temperature (°C)'}
          toggleHumidity={toggleHumidity}
          setToggleHumidity={setToggleHumidity}
          hasHumidityToggle={hasHumidityToggle}
          setFilterByDateCheck={setFilterByDateCheck}
          filterByDateCheck={filterByDateCheck}
          dateRange={dateRange}
          setDateRange={setDateRange}
          maxSelectionDays={props?.layer_type=='temp_hum'?90:30}
        />

        {
          (filterByDateCheck && (graphFilter.filterMain == null || graphFilter.filterMain == ''))  ? '' : 
          <RefreshMultipleTimeseries
            data={data}
            payload2={payload2}
            charRef={charRef}
            apiParams={apiParams}
            chartApiData={chartApiData}
            setChartApiData={setChartApiData}
            lastTimeStamp={lastTimeStamp}
            setLastTimeStamp={setLastTimeStamp}
            graphApiCall={graphApiCall}
            graphAddPointApiCall={graphAddPointApiCall}
          />
        }
            <DateRangeSet
                  graphFilter={graphFilter}
                  setFilterByDateCheck={setFilterByDateCheck}
                  filterByDateCheck={filterByDateCheck}
                  dateRange={dateRange}
                  setDateRange={setDateRange}
                  setGraphFilter={setGraphFilter}
                  initialFilter={INITIALFILTER}
                  setApiDateRange={setApiDateRange}
                  graphInfo={graphInfo}
                />
      </Suspense>
    </div>
  );
}
